export enum Orientation {
  NORMAL = 0,
  XTOZ_ZTOX = 1,
  XTOY_YZOX = 2,
  YTOZ_ZTOY = 3,
  XTOZ_ZTOY_YTOX = 4,
  XTOY_YTOZ_ZTOX = 5,
}
